import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TagComponentComponent } from '@app-components/common/tag-component/tag-component.component';
import { TranslateModule } from '@ngx-translate/core';
import { TagContract } from '@app-types/api/tag';
import { TagsButtonComponent } from '@app-components/email/action-buttons/tags-button/tags-button.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-field-tags-list',
  imports: [
    TagComponentComponent,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    TagsButtonComponent,
    NgClass,
  ],
  templateUrl: './field-tags-list.component.html',
  styleUrls: ['./field-tags-list.component.scss'],
})
export class FieldTagsListComponent {
  @Input() thisTags: TagContract[];
  @Input() label?: string;
  @Input() isForm = false;
  @Output() openAddTag = new EventEmitter<void>();
  constructor() {}
}
